import { Tabs, TabsList, TabsTrigger } from '@zond/ui';
import { useTranslation } from 'react-i18next';

/**
 * Props for the ReportAttendanceControls component
 */
interface ReportAttendanceControlsProps {
  showAverageOnly: boolean;
  onModeChange: (showAverageOnly: boolean) => void;
}

/**
 * Controls component for the attendance chart in reports
 * Allows switching between average and individual modes
 */
export function ReportAttendanceControls({ showAverageOnly, onModeChange }: ReportAttendanceControlsProps) {
  const { t } = useTranslation('reports');
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <span className="text-2xl font-semibold leading-none tracking-tight">{t('attendance.title')}</span>
      </div>

      <div className="flex items-center gap-2">
        <Tabs
          defaultValue={showAverageOnly ? 'average' : 'individual'}
          value={showAverageOnly ? 'average' : 'individual'}
          onValueChange={(value) => onModeChange(value === 'average')}
        >
          <TabsList>
            <TabsTrigger value="average" className="flex items-center">
              <span>{t('attendance.average')}</span>
            </TabsTrigger>
            <TabsTrigger value="individual" className="flex items-center">
              <span>{t('attendance.byUser')}</span>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}
